export default __webpack_public_path__ + "static/media/green Ribbon 1.8dca7745.svg";